<template>
  <div class="flex dialog-content">
    <div class="flex-wrap justify-space-between main-content overflow-y relative">
      <p v-if="currentRoute === 'step3'" class="step3Note">※画像は全て光沢仕上げとなっています</p>
      <figure v-for="(data, idx) in stepData"
              :key="idx"
              class="transition"
              :class="{active:selectedItem && selectedItem.val === data.val}">
        <div class="image-wrapper transition oval">
          <div class="flex chips">
            <span class="flex align-center justify-center title text-center">{{data.name}}</span>
            <button class="detail oval text-center pointer transition" @click="toggleSubDialog(data, true)">詳しく</button>
          </div>
          <img v-if="applyRule(data.val).visible" class="oval pointer" :src="currentImage(data)" alt="image" @click="storeItem(data)">
          <img v-else class="oval pointer" :src="currentImage(data)" alt="image">
          <div v-if="!applyRule(data.val).visible" class="flex align-center justify-center select-button rule-text">
            <div class="overlay"></div>
            <p class="warning">選択できません<br>{{applyRule(data.val).rule}}</p>
          </div>
          <transition name="slideUp">
            <div class="flex align-center justify-center select-button" v-if="selectedItem && selectedItem.val === data.val">
              <div class="overlay"></div>
              <button v-if="['step6', 'step7'].includes(currentRoute)" class="oval transition pointer" @click="removeItem(selectedItem)">選択解除</button>
              <button v-else class="oval transition pointer" @click="removeItem()">選択解除</button>
              <button class="oval transition pointer" @click="selectItem()">選択</button>
            </div>
          </transition>
        </div>
      </figure>
    </div>
  </div>
</template>

<script>
import useImageBuilder from "@/modules/moduleA/helpers/useImageBuilder";
import useDialogBuilder from "@/modules/moduleA/helpers/useDialogBuilder";
import useRules from "@/modules/moduleA/helpers/useRules";

export default {
  name: "DiType2",
  props:{stepData:Array,},
  setup(){
    const {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem} = useDialogBuilder()
    const {currentImage} = useImageBuilder(currentRoute.value)
    const {applyRule} = useRules(currentRoute.value)

    return {currentRoute, toggleSubDialog, storeItem, selectItem, removeItem, selectedItem, currentImage, applyRule}
  }
}
</script>

<style>
.dialog-content {
  height: calc(100% - 70px);
}
.dialog-content > .tab-wrapper {
  padding: 10px 0 8px 0;
  border-bottom: 1px solid #f5f6fa;
}
.dialog-content > .tab-wrapper > button {
  position: relative;
}
.dialog-content > .tab-wrapper > button.active::after {
  content: "";
  position: absolute;
  left: 0;
  background-color: #171717;
  bottom: -9px;
  width: 100%;
  height: 1px;
}
.dialog-content > h3.title,
.dialog-content > .diamond-color-wrapper > h3.diamond-title {
  font-weight: 400;
  font-size: 1.1rem;
  padding: 10px 0;
}
.dialog-content > .diamond-color-wrapper > h5.selected-color {
  font-weight: 400;
  color: #797979;
  font-size: 1.1rem;
  padding-bottom: 10px;
}
.dialog-content > .diamond-color-wrapper > .button-wrapper {
  margin-bottom: 10px;
}
.dialog-content > .diamond-color-wrapper > .button-wrapper > button {
  width: 35px;
  height: 35px;
  padding: 5px;
  border-radius: 50%;
  margin: 0 10px;
  border: 1px solid white;
}
.dialog-content > .diamond-color-wrapper > .button-wrapper > button.active {
  border-color: #1e272e;
}
.dialog-content > .diamond-color-wrapper > .button-wrapper > button > span {
  border-radius: 50%;
  display: block;
  width: 100%;
  height: 100%;
}


.dialog-content > .main-content {
  padding: 30px 40px 0 40px;
}
.dialog-content > .main-content > figure {
  position: relative;
  width: 48%;
  margin-bottom: 30px;
  border: 2px dashed white;
  border-radius: 14px;
}
.dialog-content > .main-content > figure:hover {
  border-color: #dcdde1;
  background-color: white;
}
.dialog-content > .main-content > figure.active {
  border: 4px solid #5b5b5d;
}

/* chip buttons */
.dialog-content > .main-content > figure > .image-wrapper > .chips {
  position: absolute;
  z-index: 6;
  right: 10px;
  top: 10px;
}
.dialog-content > .main-content > figure > .image-wrapper > .chips > span.title {
  font-size: 1.2rem;
  backdrop-filter: blur(3px);
  opacity: .8;
}
.dialog-content > .main-content > figure > .image-wrapper > .chips > button.detail {
  position: relative;
  z-index: 2;
  width: 60px;
  height: 40px;
  margin: 0 10px;
  padding-top: 2px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .2);
  border: 2px solid rgba(220, 221, 225,1.0);
  color: #22252f;
}
.dialog-content > .main-content > figure > .image-wrapper > .chips > button.detail:hover {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}


/* image */
.dialog-content > .main-content > figure > .image-wrapper {
  position: relative;
  overflow: hidden;
  height: 100%;
}
.dialog-content > .main-content > figure:hover > .image-wrapper,
.dialog-content > .main-content > figure.active > .image-wrapper {
  transform: translate(13px, -13px);
  box-shadow: 0 25px 20px -25px rgba(0, 0, 0, .5);

}
.dialog-content > .main-content > figure > .image-wrapper > img {
  width: 100%;
  height: 100%;
}
.dialog-content > .main-content > figure > .image-wrapper > img.absolute {
  left: 0;
  top: 0;
}
.dialog-content > .main-content > figure > .image-wrapper > img.multiply {
  mix-blend-mode: multiply;
}
.dialog-content > .main-content > figure > .image-wrapper > .select-button {
  position: absolute;
  bottom: 0;
  z-index: 5;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  height: 70px;
  width: 100%;
  transition: .15s;
}
.dialog-content > .main-content > figure > .image-wrapper > .substitute {
  position: relative;
  overflow: hidden;
  height: 100%;
  border-radius: 14px;
}
.dialog-content > .main-content > figure > .image-wrapper > .substitute > img {
  width: 100%;
  height: 100%;
}
.dialog-content > .main-content > figure > .image-wrapper > .substitute > img.absolute {
  left: 0;
  top: 0;
}
.dialog-content > .main-content > figure > .image-wrapper > .select-button > .overlay {
  position: absolute;
  bottom: 0;
  border-bottom-right-radius: 14px;
  border-bottom-left-radius: 14px;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(3px);
  z-index: 1;
}
.dialog-content > .main-content > figure > .image-wrapper > .select-button > button {
  position: relative;
  z-index: 2;
  width: 100px;
  height: 40px;
  margin: 0 10px;
  padding-top: 2px;
  letter-spacing: 1.2px;
  background-color: rgba(245, 246, 250, .3);
  border: 2px solid rgba(220, 221, 225,1.0);
  color: #22252f;
}
.dialog-content > .main-content > figure > .image-wrapper > .select-button > button:nth-of-type(2) {
  background-color: #171717;
  border-color: white;
  color: white;
}
.dialog-content > .main-content > figure > .image-wrapper > .select-button > button:hover {
  transform: translateY(-3px);
  background-color: #171717;
  border-color: white;
  color: white;
}
.dialog-content > .main-content > figure > .image-wrapper > .rule-text > .warning {
  position: relative;
  z-index: 2;
  padding: 10px 40px 0 20px;
  font-size: .8rem;
}

.dialog-content .step3Note {
  position: absolute;
  top: 0;
  text-align: center;
  font-size: .8rem;
}
@media screen and (max-width: 736px) {
  .dialog-content .step3Note {
    position: static;
    margin-bottom: 10px;
  }
  .dialog-content > .main-content > figure > .image-wrapper > .chips > button.detail {
    width: 100px;
  }
}
</style>
